// Libraries
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import createMuiTheme from 'material-ui/styles/theme';
import createPalette from 'material-ui/styles/palette';
import createTypography from 'material-ui/styles/typography';
import { green, amber, red } from 'material-ui/colors';
import injectTapEventPlugin from 'react-tap-event-plugin';
import Layout from './components/layout';

// CSS
// import './App.css';
// Hello

injectTapEventPlugin();

const abopalette = createPalette({
  primary: green,
  accent: amber,
  error: red,
  type: 'light',
});
const typography = createTypography(abopalette);

let abotheme = createMuiTheme({ palette: abopalette });

abotheme = {
  ...abotheme,
  typography: {
    ...typography,
    body1: {
      ...typography.body1,
      fontSize: '18px',
      lineHeight: '150%',
    },
    headline: {
      ...typography.headline,
      marginBottom: '20px',
    },
    subheading: {
      ...typography.subheading,
      fontSize: '18px',
    },
    display2: {
      ...typography.display2,
      fontFamily: '"Russo One","Helvetica Neue",Helvetica,Arial,sans-serif',
    },
    title: {
      ...typography.title,
      fontFamily: '"Russo One","Helvetica Neue",Helvetica,Arial,sans-serif',
      fontSize: '24px',
    },
  },
};


const app = () => (
  <MuiThemeProvider theme={abotheme}>
    <Router>
      <Layout />
    </Router>
  </MuiThemeProvider>
);

export default app;



// WEBPACK FOOTER //
// ./src/App.jsx